import Service, { service } from '@ember/service';

export default class MessagingLoggingService extends Service {
  @service intl;
  @service messaging;

  trackEvent(intlKey, additionalProperties = {}) {
    const intlAction = this.intl.t(`${intlKey}.action`);
    const intlObject = this.intl.t(`${intlKey}.object`);
    const eventName = `${intlObject} ${intlAction}`;
    this.messaging.trackEvent(eventName, {
      ...additionalProperties,
      action: intlAction,
      object: intlObject,
    });
  }

  get bugsnagClient() {
    if (typeof window === 'undefined') {
      return undefined;
    }

    return window._bugsnagClient;
  }

  get #useBugsnag() {
    return Boolean(this.bugsnagClient);
  }

  // Ember Data error messages embed the response body, which can carry patient
  // names. Report a generic error that keeps only the HTTP status.
  logGeneralError(error, context = {}) {
    const reported = new Error(this.intl.t('emc.general_error'));
    const status = Number(error?.status ?? error?.errors?.[0]?.status);
    if (Number.isInteger(status)) reported.status = status;
    this.error(reported, context);
  }

  error(error, context = {}) {
    const err = error instanceof Error ? error : new Error(String(error));

    if (this.#useBugsnag) {
      this.bugsnagClient.notify(err, event => {
        event.addMetadata('ember-messaging-client', context);
      });
    } else {
      console.error('[ember-messaging-client]', err.message, context);

      if (err.stack) {
        console.error(err.stack);
      }
    }
  }

  warn(message, context = {}) {
    if (this.#useBugsnag) {
      const err = new Error(message);
      this.bugsnagClient.notify(err, event => {
        event.severity = 'warning';
        event.addMetadata('ember-messaging-client', context);
      });
    } else {
      console.warn('[ember-messaging-client]', message, context);
    }
  }
}
